const location = {
  title: 'Permite el acceso a la ubicación',
  description: 'Este es un requisito de seguridad de este proceso de firma.',
  action: 'Avanzar',
  error: '¡Activa la ubicación en tu navegador!',
  help: '¿Dificultades para permitir acceso?',
};

export default location;
